import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../../lib/api";
import { useApp } from "../../context/AppContext";
import ProductCard from "../../components/store/ProductCard";

export default function BrandPage() {
  const { slug } = useParams();
  const { locale } = useApp();
  const [b, setB] = useState(null);
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get(`/store/brands/${slug}`).then((r) => {
      setB(r.data);
      return api.get("/store/products", { params: { market: locale.market, brand: r.data.id } });
    }).then((r) => setItems(r.data.items)).catch(() => setB(false));
  }, [slug, locale.market]);
  if (b === false) return <div className="p-16">Marque introuvable.</div>;
  if (!b) return <div className="p-16 label-xs">Chargement…</div>;
  return (
    <div style={{ background: b.colors?.primary }} data-testid={`brand-page-${b.slug}`}>
      <section className="max-w-7xl mx-auto px-5 md:px-10 py-20">
        <div className="label-xs" style={{ color: b.colors?.accent }}>{b.categories.join(" · ")}</div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold mt-4" style={{ fontFamily: b.font }}>{b.name}</h1>
        <p className="text-muted-foreground mt-6 max-w-xl">{b.tagline}</p>
        <p className="text-xs mt-2" style={{ color: b.colors?.accent }}>Ton : {b.tone}</p>
      </section>
      <section className="max-w-7xl mx-auto px-5 md:px-10 pb-20 grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-12">
        {items.map((p, i) => <ProductCard key={p.id} p={p} i={i} />)}
      </section>
    </div>
  );
}
